import { ContentTag, provideComponent } from "scrivito"

import { ButtonGroupWidget } from "./ButtonGroupWidgetClass"

provideComponent(ButtonGroupWidget, ({ widget }) => {
  return (
    <ContentTag
      className="button-group button-group-widget"
      content={widget}
      attribute="buttons"
    />
  )
})
